<div class="main-container-create">
    <div class="dialog-header">
        <div class="title-text">
            <span *ngIf="data.mode == 'editCoupon' || data.mode == 'editPool'">Edit </span>
            <!-- <span *ngIf="data.mode == 'clone'">Clone</span> -->
            <span *ngIf="data.mode == 'create'">Create </span> 
            <span *ngIf="data.mode == 'create' || data.mode == 'editPool'"> Coupon Pool</span>
            <span *ngIf="data.mode == 'editCoupon'"> {{data.couponCode}} Coupon</span>
        </div>
        
        <div class="flex align-items-center">
            <span *ngIf="data.hasEditLock" class="sp-style-1 info-text-container orange-style">
                Redeemed Coupon Cannot be edited
            </span>
            <span *ngIf="data.hasSpecialConfig" class="sp-style-1 info-text-container orange-style" [matTooltip]="'Coupon has configuration differnt from the pool'" [matTooltipShowDelay]="200">
                Special config
            </span>
            <button class="primary-button button-hover-effect save-button" (click)="saveConfig()" [style.background]="isSaving?'white':''" *ngIf="!data.hasEditLock"> 
                <span class="material-symbols-outlined" *ngIf="!isSaving">save</span>
                <span style="margin-left: 1rem;" *ngIf="!isSaving">Save</span>
                <app-qubriux-loading [size]="25" *ngIf="isSaving"></app-qubriux-loading>
            </button>
            <button class="primary-button secondary-button button-hover-effect" (click)="closedialog(false)">Close</button>
        </div>
    </div>

    <app-qubriux-loading [size]="55" class="margin-auto" [loadingText]="'Fetching data...'" *ngIf="dataLoading"></app-qubriux-loading>
    <div class="main-content-container top-margin-standard" *ngIf="!(dataLoading)" [ngClass]="{'disabled-edit':data.hasEditLock}">

        <div class="flex gap-3 flex-1" *ngIf="data.mode != 'editCoupon'">
            <div class="width-50">
                <label class="main-label-style">Pool Name</label><span class="qb-imp-color">*</span>
                <div class="rp-name-inp-container">
                    <input class="rp-name-inp" type="text" placeholder="Enter your pool name" maxlength="50" #inp [(ngModel)]="poolConfig.name" (keydown)="errorFieldList = []">
                </div>
                <div class="input-sub">
                    <div class="error-text" *ngIf="errorFieldList.includes('NAME')">
                        Please enter valid name
                    </div>
                    <div class="error-text" *ngIf="errorFieldList.includes('NAMECOPY')">
                        Please enter unique name
                    </div>
                    <div class="inp-text-left">{{inp.value.length}}/{{ inp.getAttribute('maxlength')}}</div>
                </div>
            </div>
            <div class="flex-1">
                <label class="main-label-style">Pool Description</label>
                <div class="rp-name-inp-container">
                    <input class="rp-name-inp" type="text" placeholder="Enter your description" maxlength="300" #inp2 [(ngModel)]="poolConfig.description" (keydown)="errorFieldList = []">
                </div>
                <div class="input-sub">
                    <div class="inp-text-left">{{inp2.value.length}}/{{ inp2.getAttribute('maxlength')}}</div>
                </div>
            </div>
        </div>

        <div *ngIf="data.mode != 'editCoupon'" class="code-property" [ngClass]="{'disabled-edit':data.mode == 'editPool'}">
            <div class="flex gap-3 flex-1 top-margin-standard">
                <div class="width-50">
                    <label class="main-label-style">Code Length</label><span class="qb-imp-color">*</span>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="number" placeholder="Enter your value" maxlength="2" #inp3 [(ngModel)]="poolConfig.codeLength"
                                (keydown)="numberInputHandler($event,2,'number');errorFieldList = [];" min="0" max="99" (wheel)="disableWheelScroll($event)">
                    </div>
                    <div class="input-sub">
                        <div class="error-text" *ngIf="errorFieldList.includes('CODELENGTH')">
                            Please enter valid value [3-15 characters]
                        </div>
                        <div class="error-text" *ngIf="errorFieldList.includes('CAPACITY') && !errorFieldList.includes('CODELENGTH')">
                            Cannot create {{poolConfig.totalCoupons}} coupons with this code length.
                        </div>
                        <div class="inp-text-left">{{inp3.value.length}}/{{ inp3.getAttribute('maxlength')}}</div>
                    </div>
                </div>
                <div class="width-50">
                    <label class="main-label-style">Character Set</label><span class="qb-imp-color">*</span>
                    <div class="rp-name-inp-container">
                        <mat-select [(ngModel)]="codeCharacterSetSelectedValues" (selectionChange)="updateCharacterSet($event)" multiple>
                            <mat-option [value]="'ALPHABETS'">Alphabets</mat-option>
                            <mat-option [value]="'NUMBERS'">Numbers</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>

            <div class="flex gap-3 flex-1 top-margin-standard">
                <div class="width-50">
                    <label class="main-label-style">Disallowed characters</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter disallowed characters" maxlength="10" #inp6 [(ngModel)]="poolConfig.codeDisallowedCharacters"
                        (input)="poolConfig.codeDisallowedCharacters = poolConfig.codeDisallowedCharacters.toUpperCase()"  (keydown)="errorFieldList = []">
                    </div>
                    <div class="input-sub">
                        <!-- <div class="error-text" *ngIf="errorFieldList.includes('DC')">
                            Please enter valid name
                        </div> -->
                        <div class="inp-text-left">{{inp6.value.length}}/{{ inp6.getAttribute('maxlength')}}</div>
                    </div>
                </div>
                <div class="width-50">
                    <label class="main-label-style">Total Number Of Coupons</label><span class="qb-imp-color">*</span>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="number" placeholder="Enter your value" maxlength="7" #inp7 [(ngModel)]="poolConfig.totalCoupons"
                        (keydown)="numberInputHandler($event,7,'number');errorFieldList = [];" min="0" max="9999999" (wheel)="disableWheelScroll($event)" >
                    </div>
                    <div class="input-sub">
                        <div class="error-text" *ngIf="errorFieldList.includes('TOTAL')">
                            Please enter valid value [max 3000000]
                        </div>
                        <div class="inp-text-left">{{inp7.value.length}}/{{ inp7.getAttribute('maxlength')}}</div>
                    </div>
                </div>
            </div>

            <div class="flex gap-3 flex-1 top-margin-standard">
                <div class="width-50">
                    <label class="main-label-style">Code Prefix</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your prefix" maxlength="10" #inp4 [(ngModel)]="poolConfig.codePrefix"
                        (input)="poolConfig.codePrefix = poolConfig.codePrefix.toUpperCase()" (keydown)="errorFieldList = []" (keyup)="removeSpecialCharacters('codePrefix')">
                    </div>
                    <div class="input-sub">
                        <!-- <div class="error-text" *ngIf="errorFieldList.includes('CODEPREFIX')">
                            Please enter valid prefix [No special characters allowed]
                        </div> -->
                        <div class="inp-text-left">{{inp4.value.length}}/{{ inp4.getAttribute('maxlength')}}</div>
                    </div>
                </div>
                <div class="width-50">
                    <label class="main-label-style">Code Suffix</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your suffix" maxlength="10" #inp5 [(ngModel)]="poolConfig.codeSuffix"
                        (input)="poolConfig.codeSuffix = poolConfig.codeSuffix.toUpperCase()"  (keydown)="errorFieldList = []" (keyup)="removeSpecialCharacters('codeSuffix')">
                    </div>
                    <div class="input-sub">
                        <!-- <div class="error-text" *ngIf="errorFieldList.includes('CODESUFFIX')">
                            Please enter valid suffix [No special characters allowed]
                        </div> -->
                        <div class="inp-text-left">{{inp5.value.length}}/{{ inp5.getAttribute('maxlength')}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex padd p-3 align-items-center top-margin-standard">
            <div class="main-label-style">Code Type</div><span class="qb-imp-color me-3">*</span>
            <button class="type-button me-3" (click)="poolConfig.isGiftCode = false;" [ngClass]="{'active-type-button': !poolConfig.isGiftCode}">
                Normal Codes
            </button>
            <button class="type-button" (click)="poolConfig.isGiftCode = true;" [ngClass]="{'active-type-button': poolConfig.isGiftCode}">
                Gift Codes
            </button>
        </div>

        <div class="offer-fields-container" *ngIf="!poolConfig.isGiftCode">
            <app-offer-creation-simplified #offerCreationSimplifiedComp [popUpMode]="true" [showViewForCouponPool]="true" [showSaveButton]="false"
            [offerDetailsInput]="offerProperties" [lockEdit]="data.hasEditLock" ></app-offer-creation-simplified>
        </div>

        <div class="gift-field-container" *ngIf="poolConfig.isGiftCode">
            <app-gift-code-creation [showViewForCouponPool]="true" [giftCodeDetailsInput]="giftCodeProperties" [lockEdit]="data.hasEditLock" #giftCodeCreationComp></app-gift-code-creation>
        </div>
        
    </div> 
</div>
